// eslint-disable-next-line camelcase
export default class detailIF4IF_LicenseInvoices {
    load(sAction, data) {
        // call immediately after detailView is load

        if (!sAction.dataGet(data.prefix + '/fields/id/value')) {
            data.value = {};
            data.value.id = sAction.dataGet(data.prefix + '/fields/if4if_licenses_if4if_licenseinvoices_1_name/def/id_value');
            data.value.name = sAction.dataGet(data.prefix + '/fields/if4if_licenses_if4if_licenseinvoices_1_name/value');
            this.loadLicenseData(sAction, data);
        }

        if (sAction.dataGet(data.prefix + '/customData/customLines/lines')?.some((line) => ![1, '1'].includes(line.get('deleted')))) {
            sAction.dataSet(data.prefix + '/fields/invoice_amount/def/readonly', true);
        }

        this.setLinesModelsFilter(
            sAction,
            data.prefix,
            sAction.dataGet(data.prefix + '/fields/if4if_licenses_if4if_licenseinvoices_1if4if_licenses_ida/value'),
        );
    }
    update(sAction, data) {
        switch (data.field) {
            case 'if4if_licenses_if4if_licenseinvoices_1if4if_licenses_ida':
                this.loadLicenseData(sAction, data);
                this.setLinesModelsFilter(sAction, data.prefix, data.value.id);
                break;
            case 'invoice_amount': {
                const price = data.value;
                const rate = sAction.dataGet(data.prefix + '/fields/exchange_rate/value') || 1;
                const priceUSD = price / rate;
                const productValue = sAction.dataGet(data.prefix + '/fields/value/value');
                const total = (parseFloat(priceUSD) || 0) + (parseFloat(productValue) || 0);

                sAction.dsClear();
                sAction.dsAdd('set', data.prefix + '/fields/amount_usd/value', priceUSD);
                sAction.dsAdd('set', data.prefix + '/changes/fields/amount_usd', priceUSD);
                sAction.dsAdd('set', data.prefix + '/fields/total/value', total);
                sAction.dsAdd('set', data.prefix + '/changes/fields/total', total);
                sAction.dsProcess();
                break;
            }
            case 'currency_id':
            case 'billing_year':
            case 'billing_month':
                this.updateExchangeRate(sAction, data);
                break;
            case 'value': {
                const totalValue = sAction.dataGet(data.prefix + '/fields/amount_usd/value');
                const total = (parseFloat(data.value) || 0) + (parseFloat(totalValue) || 0);
                sAction.dsClear();
                sAction.dsAdd('set', data.prefix + '/fields/total/value', total);
                sAction.dsAdd('set', data.prefix + '/changes/fields/total', total);
                sAction.dsProcess();
                break;
            }
        }
        // call immediately after detailView field is update
    }
    newSubRecord(sAction, data) {
        // call immediately before route sub record
    }
    beforeSave(sAction, data) {
        // call bfore Record is save

        return true;
    }
    updateDetailLine(sAction, data) {
        switch (data.field) {
            case 'amount':
            case 'deleted': {
                const linePrefix = data.prefix.substring(0, data.prefix.lastIndexOf('/'));
                const total = sAction.dataGet(linePrefix).reduce((total, current) => {
                    if ([1, '1'].includes(current.get('deleted'))) return total;
                    return total +parseFloat(current.get('amount') || 0);
                }, 0);

                const prefix = linePrefix.substring(0, linePrefix.indexOf('/customData/'));
                sAction.dsClear();
                sAction.dsAdd('set', prefix + '/fields/invoice_amount/value', total);
                sAction.dsAdd('set', prefix + '/changes/fields/invoice_amount', total);
                sAction.dsAdd('set', prefix + '/fields/invoice_amount/def/readonly', true);
                sAction.dsProcess();

                this.update(sAction, {field: 'invoice_amount', prefix: prefix, value: total});
                break;
            }
            case 'aon_list_of_models_aon_license_invoice_products_1_name':
            case 'product': {
                const product = data.field === 'product' ? data.value : sAction.dataGet(`${data.prefix}/product`);
                const productName = sAction.translateEnum('product_solutions_enum', product);
                const modelName = data.field === 'aon_list_of_models_aon_license_invoice_products_1_name' ?
                    data.value.name :
                    sAction.dataGet(data.prefix + '/fields/aon_list_of_models_aon_license_invoice_products_1_name/value');

                let name;
                if (product && modelName) {
                    name = `${productName} – ${modelName}`;
                } else if (product) {
                    name = productName;
                } else if (modelName) {
                    name = modelName;
                }
                if (name) {
                    sAction.dataSet(`${data.prefix}/name`, name);
                }
                break;
            }
        }
    }

    loadLicenseData(sAction, data) {
        if (!data.value.id) {
            return;
        }

        const fields = {
            name: 'name',
            accounts_if4if_licenses_1accounts_ida: 'accounts_if4if_licenseinvoices_1accounts_ida',
            accounts_if4if_licenses_1_name: 'accounts_if4if_licenseinvoices_1_name',
            if4if_contracts_if4if_licenses_1if4if_contracts_ida: 'if4if_contracts_if4if_licenseinvoices_1if4if_contracts_ida',
            if4if_contracts_if4if_licenses_1_name: 'if4if_contracts_if4if_licenseinvoices_1_name',
            percent_increase_per_year: 'percent_increase_per_year',
            payment_type: 'payment_type',
            grids_code: 'grids_code',
            expected_billing_period: 'billing_month',
        };

        sAction.load();
        const licensePromise = sAction.rest.fetchData('customAction', 'POST', {
            module: 'IF4IF_Licenses',
            id: data.value.id,
            fields: Object.keys(fields),
            action: 'getBeanInfo',
        }, false);
        const productsPromise = sAction.rest.fetchData('customAction', 'POST', {
            action: 'getLicenseProducts',
            licenseId: data.value.id,
        }, false);

        Promise.all([licensePromise, productsPromise]).then(([license, products]) => {
            sAction.dsClear();
            for (const [key, value] of Object.entries(license)) {
                if (key === 'name') {
                    sAction.dsAdd('set', data.prefix + '/fields/' + fields[key] + '/value', `${value} – invoice`);
                    sAction.dsAdd('set', data.prefix + '/changes/fields/' + fields[key], `${value} – invoice`);
                    continue;
                }
                sAction.dsAdd('set', data.prefix + '/fields/' + fields[key] + '/value', value);
                sAction.dsAdd('set', data.prefix + '/changes/fields/' + fields[key], value);
            }

            for (const p of products) {
                const productName = sAction.translateEnum('product_solutions_enum', p.product);
                const line = {
                    name: p.model_name? `${productName} – ${p.model_name}`: productName,
                    product: p.product,
                    aon_list_of_models_aon_license_invoice_products_1_name: p.model_name,
                    aon_list_oa51a_models_ida: p.model_id,
                    amount: 0,
                    amount_usd: 0,
                    deleted: 0,
                };
                sAction.dsAdd('add', `${data.prefix}/customData/customLines/lines`, line);
            }

            sAction.dsProcess();
            sAction.unLoad();
        });
    }

    setLinesModelsFilter(sAction, prefix, licenseId) {
        if (!licenseId) {
            sAction.dataDelete(
                `${prefix}/customData/customLines/def/defaultFilter`,
                'aon_list_of_models_aon_license_invoice_products_1_name',
            );
            return;
        }

        sAction.rest.fetchData(`getLicensedModels/${licenseId}`, 'GET', null, false).then(({data}) => {
            sAction.dataSet(
                `${prefix}/customData/customLines/def/defaultFilter/aon_list_of_models_aon_license_invoice_products_1_name/id`,
                {
                    field: 'id',
                    value: data,
                    type: 'contArray',
                },
            );
        }).catch(() => {
            sAction.dataDelete(
                `${prefix}/customData/customLines/def/defaultFilter`,
                'aon_list_of_models_aon_license_invoice_products_1_name',
            );
        });
    }

    updateExchangeRate(sAction, {prefix, value, field}) {
        const currency = field === 'currency_id' ? value : sAction.dataGet(prefix + '/fields/currency_id/value');
        const year = field === 'billing_year' ? value : sAction.dataGet(prefix + '/fields/billing_year/value');
        const month = field === 'billing_month' ? value : sAction.dataGet(prefix + '/fields/billing_month/value') || 1;
        const iso = sAction.currencies[currency]?.iso4217;

        sAction.rest.fetchData(`getExchangeRate/${iso}/${year}/${month}`, 'GET', null, false).then(({data}) => {
            console.log('updateExchangeRate', sAction.dataGet(prefix + '/fields/exchange_rate/value'), data);
            if (!data || data === sAction.dataGet(prefix + '/fields/exchange_rate/value')) {
                return;
            }
            const price = sAction.dataGet(prefix + '/fields/invoice_amount/value');
            const priceUSD = price / data;
            const productValue = sAction.dataGet(prefix + '/fields/value/value');
            const total = (parseFloat(priceUSD) || 0) + (parseFloat(productValue) || 0);
            const products = sAction.dataGet(prefix + '/customData/customLines/lines');

            sAction.dsClear();
            sAction.dsAdd('set', prefix + '/fields/exchange_rate/value', data);
            sAction.dsAdd('set', prefix + '/changes/fields/exchange_rate', data);

            sAction.dsAdd('set', prefix + '/fields/amount_usd/value', priceUSD);
            sAction.dsAdd('set', prefix + '/changes/fields/amount_usd', priceUSD);

            sAction.dsAdd('set', prefix + '/fields/total/value', total);
            sAction.dsAdd('set', prefix + '/changes/fields/total', total);

            products.forEach((product, index) => {
                const productPrice = product.get('amount');
                const productPriceUSD = productPrice / data;
                sAction.dsAdd('set', `${prefix}/customData/customLines/lines/${index}/amount_usd`, productPriceUSD);
            });
            sAction.dsProcess();
        });
    }
}
